export default __webpack_public_path__ + "static/media/primeicons.e1441b13.svg";